import React from "react";
import classNames from "classnames";
import dynamic from "next/dynamic";

import { Location } from "@/custom-types/Location";
import { StoreSeo } from "@/custom-types/StoreLocator";

const DeliveryValidation = dynamic(() => import("../DeliveryValidation"), {
  ssr: false,
});

const DispensariesHeader = ({
  filtersOpen,
  seo,
  showDeliveryValidation,
  pageLocation,
}: {
  filtersOpen: boolean;
  seo: StoreSeo;
  showDeliveryValidation: boolean;
  pageLocation: Location;
}) => {
  const h1Text = seo.headline || "Recreational & medical dispensaries near you";

  return (
    <div
      className={classNames("px-lg md:pt-lg width-full", {
        hidden: filtersOpen,
      })}
      data-testid="dispensaries-header"
    >
      <h1 className="heading--s font-bold">{h1Text}</h1>
      {showDeliveryValidation && (
        <DeliveryValidation
          pageLocation={pageLocation}
          onSuccessfulResult={() => {
            window.location.href = "/dispensaries";
          }}
        />
      )}
    </div>
  );
};

export default DispensariesHeader;
